<template>
  <div>
    <TitleCard style="max-width: 97%; margin: 10px auto" title="财务管理">
      <template v-slot:subTitle>
        <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
          <li class="breadcrumb-item text-muted">FinancialManagement</li>
        </ul>
      </template>
    </TitleCard>
    <div class="container my-6" style="min-height: 100vh;">
      <div class="row g-5 g-xl-10 mb-xl-10">
        <div class="g-5 g-xl-10 ">
          <div class="card card-flush  mb-xl-10" style="display: flex;justify-content: space-around">
            <!--begin::Header-->
            <div class="card-header pt-4">
              <!--begin::Title-->
              <div class="card-title d-flex flex-column">
                <div style="display:flex;align-items: center;padding: 20px 0;">
                  <div>
                    <div style="color: #C0C0BF;">可提现金额

                    </div>
                    <div style="font-weight: bold;color: #FF7F5F;font-size: 24px;margin: 4px 0">
                      &yen;{{ sellPrice.pendingWithdrawal }}
                    </div>

                  </div>

                  <div style="margin-left: 40px">
                    <div style="color: #C0C0BF;">
                      冻结金额
                    </div>
                    <div style="font-weight: bold;font-size: 24px;margin: 4px 0">&yen;{{ sellPrice.frozen }}
                    </div>
                  </div>
                  <el-button size="small" type="primary" style="margin-left: 100px" @click="openSettableOrders">提现
                  </el-button>
                </div>

              </div>
              <!--end::Title-->
            </div>

            <!--end::Header-->

            <!--begin::Card body-->
            <div class="d-flex flex-column justify-content-end pe-0">
              <div ref="chartContainer" style="width: 100%;height: 100%"></div>
            </div>
            <!--end::Card body-->
          </div>
        </div>
        <div class="g-5 g-xl-10 ">
          <div class="card card-flush  mb-xl-10" style="display: flex;justify-content: space-around">
            <!--begin::Header-->
            <div class="card-header pt-4">
              <!--begin::Title-->
              <div class="card-title d-flex flex-column">
                <div style="display:flex;align-items: center;padding: 20px 0;">
                  <div>
                    <div style="color: #C0C0BF;">总销售额

                    </div>
                    <div style="font-weight: bold;color: #FF7F5F;font-size: 24px;margin: 4px 0">
                      &yen;{{ (sellPrice.winningTheLottery + sellPrice.toBeDrawn + sellPrice.notWinning).toFixed(2) }}
                    </div>
                    <div>
                      <el-link style="font-size: 11px" type="primary"
                               @click="$router.push('/order')"
                      >查看全部明细 <i class="el-icon-arrow-right"></i>
                      </el-link>
                      <!--&nbsp;-->
                    </div>
                  </div>
                  <div style="margin-left: 20px;padding-right: 10px">
                    <div>
                      &nbsp;
                    </div>
                    <div style="font-weight: bold;font-size: 18px;">=</div>
                    <div>
                      &nbsp;
                    </div>
                  </div>
                  <div style="margin-left: 10px">
                    <div style="color: #C0C0BF;">
                      中奖金额
                    </div>
                    <div style="font-weight: bold;font-size: 24px;margin: 4px 0">&yen;{{ sellPrice.winningTheLottery }}
                    </div>
                    <div style="color: #C0C0BF;font-size: 11px">
                      &nbsp;
                    </div>
                  </div>
                  <div style="margin-left: 20px;margin-right: 10px">
                    <div>
                      &nbsp;
                    </div>
                    <div style="font-size: 20px">
                      +
                    </div>
                    <div>
                      &nbsp;
                    </div>
                  </div>
                  <div style="margin-left: 10px">
                    <div style="color: #C0C0BF;">
                      未中奖退款金额
                    </div>

                    <div style="font-size: 24px;margin: 4px 0">&yen;{{ sellPrice.notWinning }}</div>
                    <div>
                      &nbsp;
                    </div>
                  </div>
                  <div style="margin-left: 20px;margin-right: 10px">
                    <div>
                      &nbsp;
                    </div>
                    <div style="font-size: 20px">
                      +
                    </div>
                    <div>
                      &nbsp;
                    </div>
                  </div>
                  <div style="margin-left: 10px">
                    <div style="color: #C0C0BF;">
                      待开奖金额
                    </div>

                    <div style="font-size: 24px;margin: 4px 0">&yen;{{ sellPrice.toBeDrawn }}</div>
                    <div>
                      &nbsp;
                    </div>
                  </div>
                </div>

              </div>
              <!--end::Title-->
            </div>

            <!--end::Header-->

            <!--begin::Card body-->
            <div class="d-flex flex-column justify-content-end pe-0">
              <div ref="chartContainer" style="width: 100%;height: 100%"></div>
            </div>
            <!--end::Card body-->
          </div>
        </div>
        <div class="g-5 g-xl-10 ">
          <div class="card card-flush  mb-xl-10" style="display: flex;justify-content: space-around">
            <!--begin::Header-->
            <div class="card-header pt-4">
              <!--begin::Title-->
              <div class="card-title d-flex flex-column">
                <div style="display:flex;align-items: center;padding: 20px 0;">
                  <div style="margin-right: 40px">
                    <div style="color: #C0C0BF;">粉丝收益
                    </div>

                    <div>
                      <el-link style="font-size: 11px" type="primary"
                               @click="toCheckBalance"
                      >查看全部明细 <i class="el-icon-arrow-right"></i>
                      </el-link>
                      <!--&nbsp;-->
                    </div>
                  </div>
                  <div style="margin-left: 10px">
                    <div style="color: #C0C0BF;">
                      账户可提现余额
                    </div>
                    <div style="font-weight: bold;font-size: 24px;margin: 4px 0">&yen;{{ balance }}
                    </div>

                  </div>
                  <div style="margin-left: 40px">
                    <div style="color: #C0C0BF;">
                      已发放金额
                    </div>

                    <div style="font-size: 24px;margin: 4px 0">&yen;{{ issued }}</div>
                  </div>
                  <div style="margin-left: 60px">
                    提现操作请在小程序个人中心中进行
                  </div>
                </div>

              </div>
              <!--end::Title-->
            </div>

            <!--end::Header-->

            <!--begin::Card body-->
            <div class="d-flex flex-column justify-content-end pe-0">
              <div ref="chartContainer" style="width: 100%;height: 100%"></div>
            </div>
            <!--end::Card body-->
          </div>
        </div>
        <div class="g-5 g-xl-10 ">
          <div class="card card-flush  mb-xl-10" style="display: flex;justify-content: space-around">
            <!--begin::Header-->
            <div class="card-header pt-4">
              <!--begin::Title-->
              <div class="card-title d-flex flex-column">
                <div style="display:flex;align-items: center;padding: 20px 0;">
                  <div>
                    <div style="color: #C0C0BF;">总粉丝数

                    </div>
                    <div style="font-weight: bold;color: #FF7F5F;font-size: 24px;margin: 4px 0">
                      {{ totalFans }}
                    </div>
                    <div>
                      <el-link style="font-size: 11px" type="primary"
                               @click="dialogVisible = true"
                      >查看全部明细 <i class="el-icon-arrow-right"></i>
                      </el-link>
                      <!--&nbsp;-->
                    </div>
                  </div>

                  <div style="margin-left: 40px">
                    <div style="color: #C0C0BF;">
                      今日新增粉丝数
                    </div>
                    <div style="font-weight: bold;font-size: 24px;margin: 4px 0">{{ totalFans }}
                    </div>
                  </div>
                </div>

              </div>
              <!--end::Title-->
            </div>

            <!--end::Header-->

            <!--begin::Card body-->
            <div class="d-flex flex-column justify-content-end pe-0">
              <div ref="chartContainer" style="width: 100%;height: 100%"></div>
            </div>
            <!--end::Card body-->
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="粉丝列表" :visible.sync="dialogVisible" width="80%">
      <el-table
          :data="fansList"
          style="width: 100%">
        <el-table-column
            label="头像"
            width="180">
          <template slot-scope="scope">
            <el-image :src="scope.row.headImg" style="width: 50px;height: 50px;"
                      :preview-src-list="[scope.row.headImg]"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="name"
            label="昵称">
        </el-table-column>
        <el-table-column
            prop="tel"
            label="手机号">
        </el-table-column>

      </el-table>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="params.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="params.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalFans">
      </el-pagination>
    </el-dialog>

    <el-dialog title="可提现订单" :visible.sync="withdrawVisible" width="80%">
      <div style="display: flex;align-items: center">
        <div>银行卡号:</div>
        <el-input placeholder="请输入银行卡号" v-model="cardId" style="width: 30%" size="small"
                  :disabled="cardIdDisable"></el-input>
        <el-button type="primary" v-if="cardIdDisable" @click="cardIdDisable = false" size="small"
                   style="margin-left: 20px">修改
        </el-button>
      </div>
      <el-table :data="listSettable" border @selection-change="handleSelectionChange" style="margin-top: 20px">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column
            prop="orderNo"
            label="订单号">
        </el-table-column>
        <el-table-column
            prop="disPrice"
            label="结算价">
        </el-table-column>
        <el-table-column
            prop="crTime"
            label="创建时间">
        </el-table-column>
        <el-table-column
            prop="roomId"
            label="房间号">
        </el-table-column>
      </el-table>
      <el-pagination
          @size-change="handleSizeChangeSettable"
          @current-change="handleCurrentChangeSettable"
          :current-page="paramsSettable.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="paramsSettable.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSettable">
      </el-pagination>
      <div style="margin-top: 20px;display: flex;justify-content: flex-end;">
        <el-popconfirm
            confirm-button-text='确认'
            cancel-button-text='去修改'
            icon="el-icon-info"
            icon-color="red"
            title="请确认您提现的银行卡号是否正确"
            @confirm="submitOrder"
        >
          <el-button type="primary" size="small" slot="reference">提交</el-button>
        </el-popconfirm>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 例如：import uploadFile from '@/components/uploadFile/uploadFile'

import {wxUserCountTodayFansApi, wxUserGetFansApi, wxUserMyAccountFansApi} from "@/api/WxUserApi";
import {getSellPriceApi, getSettableApi} from "@/api/orderApi";
import {addWithdrawalPassOrRejectApi} from "@/api/WithdrawalApplicationApi";

export default {
  name: 'index',
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    // patientIn: {
    //   type: Object,
    //   default () {
    //     return {}
    //   }
    // }
  },
  data() {
    // 这里存放数据
    return {
      withdrawVisible: false,
      dialogVisible: false,
      params: {
        current: 1,
        size: 10
      },
      fansList: [],
      totalFans: 0,
      todayFans: 0,
      balance: 0,
      issued: 0,
      sellPrice: {
        notWinning: 0,
        toBeDrawn: 0,
        winningTheLottery: 0,
        pendingWithdrawal: 0,
        frozen: 0
      },
      paramsSettable: {
        current: 1,
        size: 10
      },
      totalSettable: 0,
      listSettable: [],
      cardId: "",
      cardIdDisable: true,
      submitOrderList: []
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 方法集合
  methods: {
    handleSelectionChange(val) {
      this.submitOrderList = val.map(item => item.orderNo)
    },
    openSettableOrders() {
      /*      if (this.$store.getters.userInfo.canWithdrawal == false){
              this.$confirm("您还未完成实名认证，请在小程序使用店长账号进行实名认证","提示",{
                confirmButtonText: '确认',
                showCancelButton: false
              })
              return
            }*/
      if (this.sellPrice.pendingWithdrawal == 0) {
        this.$message.error({
          message: "您没有可提现的订单",
        })
        return;
      }
      this.getSettable()
      this.cardId = this.$store.getters.userInfo.cardId
      this.withdrawVisible = true
    },
    async getSettable() {
      let {data} = await getSettableApi(this.paramsSettable);
      this.listSettable = data.rows
      this.totalSettable = data.total
    },
    handleSizeChangeSettable(val) {
      this.paramsSettable.size = val;
      this.getSettable()
    },
    handleCurrentChangeSettable(val) {
      this.paramsSettable.current = val;
      this.getSettable()
    },
    handleSizeChange(val) {
      this.params.size = val;
      this.wxUserGetFans()
    },
    handleCurrentChange(val) {
      this.params.current = val;
      this.wxUserGetFans()
    },
    toCheckBalance() {
      this.$message.info("收益明细请在小程序个人中心进行查看")
    },
    async wxUserGetFans() {
      let {data} = await wxUserGetFansApi()
      this.fansList = data.rows
      this.totalFans = data.total
    },
    async wxUserCountTodayFans() {
      let {data} = await wxUserCountTodayFansApi();
      if (data) {
        this.totalFans = data
      }
    },
    async wxUserMyAccountFans() {
      let {data} = await wxUserMyAccountFansApi();
      this.balance = data.balance
      this.issued = data.issued
    },
    async getSellPrice() {
      let {data} = await getSellPriceApi();
      this.sellPrice = data
    },
    async submitOrder() {
      if (this.submitOrderList.length <= 0) {
        this.$message.error("请选择订单")
        return
      }
      if (this.cardId == "") {
        this.$message.error("请填写银行卡号")
        return
      }
      await addWithdrawalPassOrRejectApi({
        orderNos: this.submitOrderList,
        cardId: this.cardId,
      })
      await this.getSellPrice()
      this.withdrawVisible = false
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.wxUserGetFans()
    this.wxUserCountTodayFans()
    this.wxUserMyAccountFans()
    this.getSellPrice()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() {
  }, // 生命周期 - 创建之前
  beforeMount() {
  }, // 生命周期 - 挂载之前
  beforeUpdate() {
  }, // 生命周期 - 更新之前
  updated() {
  }, // 生命周期 - 更新之后
  beforeDestroy() {
  }, // 生命周期 - 销毁之前
  destroyed() {
  }, // 生命周期 - 销毁完成
  activated() {
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped lang="scss">
//@import url(); 引入公共css类
</style>